import React from "react";
import { motion } from "framer-motion";
import { DollarSign, TrendingUp, Zap, Shield, Building, Clock } from "lucide-react";
import { metrics } from "../data/mock";

const iconMap = {
  DollarSign,
  TrendingUp,
  Zap,
  Shield,
  Building,
  Clock,
};

const MetricsBar = () => {
  return (
    <section
      id="about"
      style={{
        padding: "60px 7.6923%",
        background: "var(--bg-primary)",
        borderTop: "1px solid var(--border-subtle)",
        borderBottom: "1px solid var(--border-subtle)",
      }}
    >
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
        }}
      >
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          style={{
            textAlign: "center",
            marginBottom: "60px",
          }}
        >
          <h2
            style={{
              fontSize: "48px",
              fontWeight: 600,
              color: "var(--text-primary)",
              marginBottom: "16px",
            }}
          >
            Impact Metrics
          </h2>
          <p style={{ fontSize: "18px", color: "var(--text-muted)" }}>
            Measurable results from securing and optimizing cloud infrastructure
          </p>
        </motion.div>

        {/* Metrics Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "30px",
          }}
        >
          {metrics.map((metric, index) => {
            const Icon = iconMap[metric.icon];
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ y: -5 }}
                className="glass"
                style={{
                  padding: "30px",
                  borderRadius: "0px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  gap: "16px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
              >
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    background: "rgba(0, 255, 209, 0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "0px",
                  }}
                >
                  <Icon size={32} color="var(--brand-primary)" />
                </div>
                <div
                  style={{
                    fontSize: "48px",
                    fontWeight: 700,
                    color: "var(--brand-primary)",
                    lineHeight: 1,
                  }}
                >
                  {metric.value}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    color: "var(--text-secondary)",
                    fontWeight: 500,
                  }}
                >
                  {metric.label}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MetricsBar;
